(function () {
  if (window.DexcaHomepage) {
    window.DexcaHomepage.initAll(document);
    return;
  }

  function initDexcaHomepage(root) {
    if (!root || root.dataset.dxInitialized === 'true') return;
    root.dataset.dxInitialized = 'true';

    function navigateAfterEndSwipe(rail, link) {
      if (!rail || !link || !link.href || link.getAttribute('href') === '#') return;

      var startX = 0;
      var startY = 0;

      rail.addEventListener(
        'touchstart',
        function (event) {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      rail.addEventListener(
        'touchend',
        function (event) {
          var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
          var deltaX = event.changedTouches[0].clientX - startX;
          var deltaY = event.changedTouches[0].clientY - startY;

          if (atEnd && deltaX < -55 && Math.abs(deltaX) > Math.abs(deltaY)) {
            window.location.href = link.href;
          }
        },
        { passive: true }
      );
    }

    navigateAfterEndSwipe(
      root.querySelector('.dx-moment-rail'),
      root.querySelector('.dx-moments-cta')
    );
    navigateAfterEndSwipe(
      root.querySelector('.dx-review-rail'),
      root.querySelector('.dx-reviews-cta')
    );

    root.querySelectorAll('a[href="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
      });
    });
  }

  function initMobileStickyCta(bar) {
    if (!bar || bar.dataset.dxStickyInitialized === 'true') return;

    bar.dataset.dxStickyInitialized = 'true';
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var frameRequested = false;

    function updateStickyCta() {
      frameRequested = false;
      var hero = document.querySelector('.dx-hero');
      var shouldShow = Boolean(
        mobileQuery.matches && hero && hero.getBoundingClientRect().bottom <= 0
      );
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function requestUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateStickyCta);
    }

    bar.dxStickyCleanup = function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (mobileQuery.removeEventListener) {
        mobileQuery.removeEventListener('change', requestUpdate);
      } else {
        mobileQuery.removeListener(requestUpdate);
      }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', requestUpdate);
    } else {
      mobileQuery.addListener(requestUpdate);
    }

    updateStickyCta();
  }

  function initAllDexcaHomepages(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.dx-home')) {
      initDexcaHomepage(context);
    }
    context.querySelectorAll('.dx-home').forEach(initDexcaHomepage);

    if (context.matches && context.matches('[data-dx-mobile-sticky-cta]')) {
      initMobileStickyCta(context);
    }
    context.querySelectorAll('[data-dx-mobile-sticky-cta]').forEach(initMobileStickyCta);
  }

  window.DexcaHomepage = { initAll: initAllDexcaHomepages };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllDexcaHomepages(document);
    });
  } else {
    initAllDexcaHomepages(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllDexcaHomepages(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var bar = event.target.querySelector('[data-dx-mobile-sticky-cta]');
    if (bar && bar.dxStickyCleanup) bar.dxStickyCleanup();
  });
})();
